import { useNavigate } from "react-router-dom";
import { LoginForm } from "./LoginForm";
import { ThemePicker } from "../components/ThemePicker";

/** Die eigenständige Login-Seite.
 *
 *  Seit es das öffentliche Dashboard gibt, landet hier niemand mehr
 *  unfreiwillig — die Seite bleibt für Lesezeichen und alte Verknüpfungen,
 *  und weil eine volle Seite auf dem Telefon angenehmer ist als ein Dialog. */
export function Login() {
  const nav = useNavigate();
  return (
    <div className="login-shell">
      <div className="login-bg" aria-hidden />
      <LoginForm onDone={() => nav("/", { replace: true })} />
      <div className="login-theme">
        <ThemePicker />
      </div>
    </div>
  );
}
